import { axios } from '@/utils/request'

export function addObj (obj) {
  return axios({
    url: '/studentManage/signup',
    method: 'post',
    data: obj
  })
}

export function getSmsCaptcha (mobile) {
  return axios({
    url: '/studentManage/smsCode/' + mobile,
    method: 'get'
  })
}

export function getStudent () {
  return axios({
    url: '/studentManage/info',
    method: 'get'
  })
}
export function putObj (obj) {
  return axios({
    url: '/studentManage',
    method: 'put',
    data: obj
  })
}

export function putObjPho (obj) {
  return axios({
    url: '/studentManage/updatePho',
    method: 'put',
    data: obj
  })
}
export function updatePassword (obj) {
  return axios({
    url: '/studentManage/updatePassword',
    method: 'put',
    data: obj
  })
}
export function checkPassword (password) {
  return axios({
    url: '/studentManage/checkPassword/' + password,
    method: 'get'
  })
}

export function uploadObj (obj) {
  return axios({
    url: '/studentManage/upload',
    method: 'post',
    data: obj
  })
}
export function checkPhone (phone) {
  return axios({
    url: '/studentManage/checkPhone/' + phone,
    method: 'get'
  })
}

export function queryByPhone (phone) {
  return axios({
    url: '/studentManage/queryByPhone/' + phone,
    method: 'get'
  })
}

export function checkCode (obj) {
  return axios({
    url: '/studentManage/checkCode',
    method: 'get',
    params: obj
  })
}

export function resetPwd (obj) {
  return axios({
    url: '/studentManage/resetPwd',
    method: 'put',
    data: obj
  })
}
